/* Nordicsell 2026-10-22 (Viktor/Leo, B-013): storleksval pa produktsidan.
   1) Fel storlek kunde hamna i varukorgen: temat byter variant-id i kopformularet
      forst 300-600 ms efter klicket (nar sektionen hamtats om). Har satts id direkt
      vid klicket och kontrolleras igen nar kunden trycker pa kop.
   2) Ingen storlek ar forvald (som Boozt/Zalando): har produkten flera storlekar
      maste kunden valja en. Annars stoppas kopet och "Valj storlek" visas.
   Galler bara huvudprodukten pa produktsidan (inte snabbvyn).
   OBS: anvand form.getAttribute('id') - form.id ger <input name=id> i kopformularet.
   ATERGANG: ta bort raden med ns-storlek.js i layout/theme.liquid. */
(function () {
  if (window.nsStorlekAktiv) return;
  window.nsStorlekAktiv = true;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var STORLEK = /^(storlek|size|storlekar|skostorlek)$/i;
  var produkt = null;
  var vald = false;

  fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
    produkt = p;
    markera();
  }).catch(function () {});

  function huvudform() {
    var f = document.querySelector('form[id^="product-form-template"][id$="__main"]');
    return f;
  }
  function storleksIndex() {
    if (!produkt) return -1;
    for (var i = 0; i < produkt.options.length; i++) {
      var o = produkt.options[i];
      if (STORLEK.test((o.name || o).toString().trim()) && o.values && o.values.length > 1) return i;
    }
    return -1;
  }
  function valdaVarden(form) {
    var v = [];
    produkt.options.forEach(function (o, i) {
      var namn = (o.name || o).toString();
      var radio = document.querySelector('input[type=radio][form="' + form.getAttribute('id') + '"][name^="' + namn + '-"]:checked');
      var sel = document.querySelector('select[form="' + form.getAttribute('id') + '"][name^="' + namn + '"]');
      v[i] = radio ? radio.value : (sel ? sel.value : null);
    });
    return v;
  }
  function hittaVariant(form) {
    if (!produkt) return null;
    var v = valdaVarden(form);
    for (var i = 0; i < produkt.variants.length; i++) {
      var pv = produkt.variants[i], ok = true;
      for (var k = 0; k < v.length; k++) { if (v[k] !== null && pv.options[k] !== v[k]) { ok = false; break; } }
      if (ok) return pv;
    }
    return null;
  }
  function sattId(form) {
    var pv = hittaVariant(form);
    if (!pv) return;
    var gammal = form.querySelector('[name=id]') && form.querySelector('[name=id]').value;
    document.querySelectorAll('form[action*="/cart/add"] [name=id]').forEach(function (inp) {
      if (inp.closest('form') === form || inp.value === gammal) inp.value = pv.id;
    });
  }
  function storleksFalt(form) {
    var idx = storleksIndex();
    if (idx < 0) return null;
    var namn = (produkt.options[idx].name || produkt.options[idx]).toString();
    var radio = document.querySelector('input[type=radio][form="' + form.getAttribute('id') + '"][name^="' + namn + '-"]');
    return radio ? radio.closest('fieldset') : null;
  }
  function markera() {
    var form = huvudform();
    if (!form || vald) return;
    var fs = storleksFalt(form);
    if (!fs || fs.classList.contains('ns-valj')) return;
    fs.classList.add('ns-valj');
    var t = fs.querySelector('[data-selected-swatch-value]');
    if (t) t.textContent = 'välj';
  }
  function visaFel(fs) {
    if (!fs) return;
    fs.classList.add('ns-valj--fel');
    if (!fs.parentNode.querySelector('.ns-valj-msg')) {
      var p = document.createElement('p');
      p.className = 'ns-valj-msg';
      p.setAttribute('role', 'alert');
      p.textContent = 'Välj storlek';
      fs.insertAdjacentElement('afterend', p);
    }
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function rensaFel() {
    document.querySelectorAll('.ns-valj-msg').forEach(function (e) { e.remove(); });
    document.querySelectorAll('.ns-valj, .ns-valj--fel').forEach(function (e) { e.classList.remove('ns-valj', 'ns-valj--fel'); });
  }

  document.addEventListener('change', function (e) {
    var t = e.target, form = huvudform();
    if (!form || !t.matches || !t.matches('input[type=radio], select')) return;
    if (t.getAttribute('form') !== form.getAttribute('id')) return;
    var fs = produkt ? storleksFalt(form) : null;
    if (fs && fs.contains(t)) { vald = true; rensaFel(); }
    sattId(form);
  }, true);

  function vidKop(e) {
    var form = huvudform();
    if (!form || !produkt) return;
    var knapp = e.target.closest && e.target.closest('[name=add], [type=submit]');
    var arHuvud = e.type === 'submit' ? e.target === form : (knapp && (knapp.form === form || knapp.closest('sticky-atc-bar, .sticky-atc-bar, [class*=sticky-atc]')));
    if (!arHuvud) return;
    if (storleksIndex() >= 0 && !vald) {
      e.preventDefault();
      e.stopImmediatePropagation();
      visaFel(storleksFalt(form));
      return;
    }
    sattId(form);
  }
  document.addEventListener('click', vidKop, true);
  document.addEventListener('submit', vidKop, true);

  new MutationObserver(function () { if (!vald) markera(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  var s = document.createElement('style');
  s.textContent = '.ns-valj input:checked+label{box-shadow:none!important;border-color:rgb(146,148,155)!important;outline:none!important}' +
    '.ns-valj--fel label{border-color:#c4301c!important}' +
    '.ns-valj-msg{color:#c4301c;font-size:14px;margin:6px 0 0;font-weight:600;width:100%}';
  document.head.appendChild(s);
})();
